export default __webpack_public_path__ + "b81feed8afec36588c29eab449858345.png";